import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

import { postShiftReviewFormSchema, type PostShiftReviewFormValues } from "./types";

interface UsePostShiftReviewFormProps {
  onSubmitRating?: (rating: number) => Promise<void>;
  onSubmitReview: (formData: PostShiftReviewFormValues) => Promise<void>;
}

export function usePostShiftReviewForm({
  onSubmitRating,
  onSubmitReview,
}: UsePostShiftReviewFormProps) {
  const form = useForm<PostShiftReviewFormValues>({
    resolver: zodResolver(postShiftReviewFormSchema),
    defaultValues: {
      rating: undefined,
      isAnonymous: undefined,
      reviewText: "",
      softwareAnswer: undefined,
      softwareOtherText: "",
      suppliesAnswer: undefined,
      patientCountAnswer: undefined,
      parkingAnswer: undefined,
      ratingAnswers: {},
    },
    mode: "onChange",
  });

  async function submitRating(rating: number) {
    form.setValue("rating", rating, { shouldValidate: true });
    if (onSubmitRating) {
      await onSubmitRating(rating);
    }
  }

  async function submitReview() {
    const formData = form.getValues();
    await onSubmitReview(formData);
  }

  return {
    form,
    submitRating,
    submitReview,
    formValues: form.watch(),
    isValid: form.formState.isValid,
    errors: form.formState.errors,
  };
}
